import { motion } from "framer-motion";
import { ReactNode, useEffect } from "react";

type AnimatedPageProps = {
  children: ReactNode;
};

export function AnimatedPage({ children }: AnimatedPageProps) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <motion.main
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.28, ease: "easeOut" }}
    >
      {children}
    </motion.main>
  );
}
